module.exports = __webpack_public_path__ + "static/media/orlando-magic.5ee21ce6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/data/svg/orlando-magic.svg
// module id = 236
// module chunks = 0